(function () {
  'use strict';

  document.querySelector('.filter__togglers');
  const filtersToggle = document.querySelector('.filter__filter-toggle');
  const sortToggle = document.querySelector('.filter__sort-toggle');
  document.querySelector('body');
  const mediaDesktop = window.matchMedia('(min-width: 1024px)');
  const sortWrapper = document.querySelector('.js-sort');
  const filtersWrapper = document.querySelector('.filter-form__filters');
  const filterGroup = document.querySelectorAll('.filter-group');
  const activeFilters = document.querySelector('.filter-form__active-filters');
  function filtersOpenHandler() {
    filtersWrapper.classList.toggle('active');
    filtersToggle.classList.toggle('active');
    if (sortToggle && sortToggle.classList.contains('active')) {
      sortToggle.classList.remove('active');
      sortWrapper.classList.remove('active');
    }
    if (mediaDesktop.matches) {
      filterGroup.forEach(group => {
        group.setAttribute('open', true);
      });
    }
  }
  function sortOpenHandler() {
    sortWrapper.classList.toggle('active');
    sortToggle.classList.toggle('active');
    if (filtersToggle.classList.contains('active')) {
      filtersToggle.classList.remove('active');
      filtersWrapper.classList.remove('active');
    }
  }
  if (filtersToggle) {
    filtersToggle.addEventListener('click', filtersOpenHandler);
  }
  if (sortToggle) {
    sortToggle.addEventListener('click', sortOpenHandler);
  }
  if (filtersToggle && !mediaDesktop.matches) {
    const filterSummary = document.querySelectorAll('.filter-group__summary');
    filterSummary.forEach(item => {
      item.addEventListener('click', e => {
        filterGroup.forEach(filter => {
          if (filter !== e.target.parentElement) {
            filter.removeAttribute('open');
          }
        });
      });
    });
  }
  if (sortWrapper) {
    const sortInputs = sortWrapper.querySelectorAll('.sort__input');
    sortInputs.forEach(input => {
      input.addEventListener('change', function (e) {
        sortWrapper.classList.remove('active');
        const value = e.target.value;
        let params = new URLSearchParams(location.search);
        params.set('sort_by', value);
        location.search = params.toString();
      });
    });
  }
  if (filtersWrapper) {
    const filtertInputs = filtersWrapper.querySelectorAll('input');
    let active = Array.from(filtertInputs).some(input => input.checked);
    active ? activeFilters.classList.add('active') : activeFilters.classList.remove('active');
  }

})();
